import { defineStore } from "pinia";
import state from "./state";
import actions from "./actions";
import getters from "./getters";

export const useAcademyStore = defineStore("academy", {
  state,
  getters,
  actions: actions(),
});
